import { render } from "./PapersView.vue?vue&type=template&id=4975d576&scoped=true"
const script = {}

import "./PapersView.vue?vue&type=style&index=0&id=4975d576&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4975d576"]])

export default __exports__